module.exports = __webpack_public_path__ + "img/musicnote.6c5cbfd1.svg";